import React, { useEffect, useState } from "react";
import s from './TableAdd.module.scss'
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { collectionAddNew, resetAddState } from "../../../store/collectionSlice";
import preloader from '../../../assets/preloader.png'
import { useTranslation } from "react-i18next";
//import { ReactComponent as Arrow } from './arrow.svg'
import Dropdown from "./DistrictsDropdown/DistrictsDropdown";
import { domain } from "../../../store/authSlice";

export const TableAdd = () => {
    const { statusAdd, errorAdded } = useSelector(state => state.collection);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const fullAPI = domain + `api/get-regions/`;    

    const initialValues = {
        name: '',
        audiorecord_local: '',
        audiorecord_xeno_canto: '',
        annotation_file: '',
        recorded_at: '',
        lat: '',
        lng: '',
        validated: false,
        deleted: false,
        audio_spectrogram: '',
        recognized_bird_image: '',
        uploader: 1,
        audio_quality_tag: '',
        recognized_bird_specie: ''
    };
    var latGPS = '';
    var lngGPS = '';
    var audio_name = '';

    const validationSchema = Yup.object().shape({
        audiorecord_local: Yup.string().required(t('fieldIsRequired')),
    });

    const handleSubmit = (values, { resetForm }) => {
        values.lat = latGPS
        values.lng = lngGPS
        values.name = values.audiorecord_local.name.replaceAll(" ", "_")

        dispatch(collectionAddNew(values))
        resetForm()
        handleScroll()
        console.log("in submit")
    };
    const handleScroll = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
    };

    const handleSelect = (value) => {
        console.log("Выбранное значение:", value);
        var value_dict = JSON.parse(value);
        var now = new Date();

        lngGPS = value_dict.lng;
        latGPS = value_dict.lat;
        audio_name = now.toString().replace(' ','_') + value_dict.en;
    };

    return (
        <div className={s.wrapper}>
            <div className={s.wrapper_body}>
                <div className={s.code_container}>
                    {statusAdd === 'failed' ? 
                    <h1 style={{color: 'red', fontSize: '40px'}}>{errorAdded}</h1> : null}
                    {statusAdd === 'succeeded' ? <h1 className={s.add_title}>
                        {t('elementAdded')}
                    </h1> : null}
                    <div className={s.formAddNew}>
                        <div className={s.formTittle}>
                            {t('addNew')}
                        </div>
                        {statusAdd === 'loading' ?
                        <div className={s.preloader_body}><img className={s.preloader} src={preloader} alt="" /></div> :    
                        <div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}

                            onSubmit={handleSubmit}
                        >
                            {({ touched, errors, values, setFieldValue }) => (
                                
                                <Form className={s.form}>                                    

                                    <div className={s.form_raw}>
                                        <label>
                                            {t('audiorecordLocal')}
                                        </label>
                                        <div>
                                            <label className={s.upload_btn} htmlFor="audiorecord_local">
                                                {t('uploadAudiorecord')}
                                            </label>
                                            <input
                                                id="audiorecord_local"
                                                name="audiorecord_local"
                                                type="file"
                                                onChange={(event) => {
                                                    setFieldValue('audiorecord_local', event.currentTarget.files[0]);
                                                }}
                                            />
                                            <span className={s.erorrs}><ErrorMessage name="fileField" /></span>
                                            {values.audiorecord_local && (<div className={s.audiorecord_local_form}>File name: {values.audiorecord_local.name}</div>)}
                                            <div>
                                                <p className={values.audiorecord_local === '' && touched.audiorecord_local ? s.inputError : null} name="audiorecord_local" type="text" />
                                                <div className={s.erorrs}><ErrorMessage name="audiorecord_local" /></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Dropdown for districts-coordinates */}
                                    <Dropdown
                                        apiUrl={fullAPI}
                                        placeholder={t("selectArea")}
                                        onChange={handleSelect}
                                    />
                                    <div className={s.form_raw}>
                                        <label htmlFor="recorded_at">{t('recordedAt')}</label>
                                        <div>
                                            <Field
                                            name="recorded_at"
                                            type="datetime-local"
                                            step='1'
                                            max={new Date().toISOString().slice(0, 9)} // limit to now
                                            />
                                            <button
                                                type="button"
                                                className={s.today_button}
                                                onClick={() => {
                                                    const now = new Date();
                                                    let month = now.getMonth() + 1; // getMonth() is 0-based
                                                    month = (month < 10 ? '0' : '') + month;
                                                    let day = now.getDate(); // getDate() is 0-based 
                                                    day = (day < 10 ? '0' : '') + day;
                                                    const now_str = (now.getFullYear() + "-" + month + "-" + day + "T" + now.toLocaleTimeString());

                                                    setFieldValue('recorded_at', now_str);
                                                }}
                                                >
                                                {t('today')}
                                            </button>
                                            <span className={s.erorrs}>
                                            <ErrorMessage name="recorded_at" />
                                            </span>
                                        </div>
                                    </div>
                                    <button className={s.submit_btn} type="submit">{t("addNew")}</button>
                                    <div className={s.file_validation_message}>
                                        <p>* {t('file_validation_message')}</p>
                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </div>
                    }                        
                    </div>

                </div>
                <div className={s.upperCloud}></div>
                <div className={s.uuderCloud}></div>
            </div>
        </div>
    );
};
